/**
 * vehicles.js  — vehicle CRUD + cascading ref lookups
 */
import api from './auth';

/* ── Vehicles ─────────────────────────────────────────────────────── */

export async function getVehicles() {
  const { data } = await api.get('/vehicles');
  return data;
}

export async function getVehicle(vehicleId) {
  const { data } = await api.get(`/vehicles/${vehicleId}`);
  return data;
}

export async function createVehicle(payload) {
  const { data } = await api.post('/vehicles', payload);
  return data;
}

export async function updateVehicle(vehicleId, payload) {
  const { data } = await api.put(`/vehicles/${vehicleId}`, payload);
  return data;
}

/* ── Reference cascades ───────────────────────────────────────────── */

export async function refMakes() {
  const { data } = await api.get('/ref/vehicle/makes');
  return data; // { success, data: [{make}] }
}

export async function refModels(make) {
  const { data } = await api.get('/ref/vehicle/models', { params: { make } });
  return data;
}

export async function refYears(make, model) {
  const { data } = await api.get('/ref/vehicle/years', { params: { make, model } });
  return data;
}

export async function refPackages(make, model, year) {
  const { data } = await api.get('/ref/vehicle/packages', { params: { make, model, year } });
  return data;
}

export async function refEngines(make, model, year, pkg) {
  const { data } = await api.get('/ref/vehicle/engines', {
    params: { make, model, year, package: pkg },
  });
  return data;
}
